// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"1fc6b241","612":"8ecdbc1f","722":"6e9befc5","1470":"6e9befc5","1545":"8ecdbc1f","4572":"6e9befc5","4974":"8ecdbc1f","5478":"8ecdbc1f","6152":"6e9befc5"}[chunkId] + ".chunk.css";
};